import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgToastModule } from "ng-angular-popup";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { ErrorHandlerInterceptor } from "./interceptors/error-handler.interceptor";
import { LocalOverrideInterceptor } from "./interceptors/local-override.interceptor";
import { ConfigService } from "./services/config.service";
import { FcErrorHandler } from "./services/fc-error-handler.service";
import { AppVersionComponent } from "./components/global/app-version/app-version.component";

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        NgToastModule,
        SweetAlert2Module.forRoot(),
        AppVersionComponent,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (c: ConfigService) => () => c.load(),
            deps: [ConfigService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LocalOverrideInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: ErrorHandler, useClass: FcErrorHandler },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
